import {combineReducers} from '@reduxjs/toolkit';
import {apiSlice} from 'services';

// reducers
import userReducer from './userSlice';
import counterReducer from './counterSlice';
import menuOpenReducer from './menuOpenSlice';
import policyRowReducer from './policyRowSlice';
import systemConfigPropertyReducer from './systemConfigProperty';

const rootReducer = combineReducers({
	[apiSlice.reducerPath]: apiSlice.reducer,
	user: userReducer,
	counter: counterReducer,
	menuOpen: menuOpenReducer,
	policyRow: policyRowReducer,
	systemConfigProperty: systemConfigPropertyReducer,
});

export default rootReducer;
